import { render, staticRenderFns, recyclableRender, components } from "./uni-swipe-action-item.vue?vue&type=template&id=fd57cc6c&scoped=true&filter-modules=eyJzd2lwZSI6eyJ0eXBlIjoic2NyaXB0IiwiY29udGVudCI6IiIsInN0YXJ0Ijo0Njk3LCJhdHRycyI6eyJzcmMiOiIuL2luZGV4Lnd4cyIsIm1vZHVsZSI6InN3aXBlIiwibGFuZyI6Ind4cyJ9LCJlbmQiOjQ2OTd9fQ%3D%3D&"
var renderjs
import script from "./uni-swipe-action-item.vue?vue&type=script&lang=js&"
export * from "./uni-swipe-action-item.vue?vue&type=script&lang=js&"
import style0 from "./uni-swipe-action-item.vue?vue&type=style&index=0&id=fd57cc6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../_@dcloudio_vue-cli-plugin-uni@2.0.0-28320200727001@@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd57cc6c",
  null,
  false,
  components,
  renderjs
)

/* custom blocks */
import block0 from "./index.wxs?vue&type=custom&index=0&blockType=script&issuerPath=D%3A%5Cproject%5CuniFrame%5Cuni-frame%5Cnode_modules%5C_%40dcloudio_uni-ui%401.2.3%40%40dcloudio%5Cuni-ui%5Clib%5Cuni-swipe-action-item%5Cuni-swipe-action-item.vue&module=swipe&lang=wxs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "node_modules/_@dcloudio_uni-ui@1.2.3@@dcloudio/uni-ui/lib/uni-swipe-action-item/uni-swipe-action-item.vue"
export default component.exports